
















































































import { idGenerator } from '../../Utils';
export default {
	name: 'GroupConfig',
	props: {
		visible: {
			type: Boolean,
			required: true,
		},
		form: {
			type: Object,
			required: true,
		},
		currentSelection: {
			type: Object,
			required: true,
		},
	},
	mounted() {},
	data() {
		return {
			icons: [],
			currentPage: 1,
			totalIcons: 0,
			loading: false,
			rules: {
				title: [
					{ required: true, message: this.$t('groupConfig.validation.titleRequired'), trigger: ['blur', 'change'] },
				],
			},
		};
	},
	computed: {
		workspaces(): Object {
			return this.$store.state.workspaces;
		},
		organizationPath(): string {
			return this.$store.getters.path;
		},
		isRootPath(): boolean {
			return this.form && this.form.path && this.form.path.indexOf('/apps') === -1;
		},
		usersProfiles(): { key: string; name: string; system?: boolean }[] {
			let arr = [...this.$store.getters.getUserProfiles];
			!this.form.editRoleFromUser &&
				this.currentSelection &&
				this.currentSelection.profiles &&
				Object.keys(this.currentSelection.profiles).forEach(key =>
					arr.push({ key: key, name: this.currentSelection.profiles[key] })
				);
			this.isRootPath && (arr = arr.filter(el => el.key !== 'inherit'));
			return arr;
		},
	},
	watch: {
		visible(newValue, oldValue): void {
			if (newValue === oldValue) return;
			setTimeout(() => this.$refs.nameField.focus(), 200);
			this.$refs.form && this.$refs.form.resetFields();
			this.isRootPath && this.form.profile === 'inherit' && (this.form.profile = 'primary');
		},
	},
	methods: {
		handleCurrentChange(val) {
			const icons = require('@/assets/linearicons/selection.json').icons;
			this.icons = icons.slice((val - 1) * 14 * 6, val * 14 * 6);
		},
		async validateForm(): Promise<boolean> {
			try {
				return await this.$refs.form.validate();
			} catch (error) {
				return false;
			}
		},
		async onEditGroup(): Promise<void> {
			const editedGroup: object = { title: this.form.title, icon: this.form.icon, profile: this.form.profile };

			const originalGroup = this.$store.getters
				.getElement({
					roleUserId: this.form.role ? this.currentSelection.role : this.currentSelection.id,
					path: this.form.path,
				})
				.find(el => el.key === this.form.key);

			['title', 'icon'].forEach(key => originalGroup[key] === editedGroup[key] && delete editedGroup[key]);

			if (Object.keys(editedGroup).length === 0) return this.$refs.drawer.closeDrawer();

			const valid = await this.validateForm();
			if (!valid) return;
			this.loading = true;

			let data: { id: string; path: string | null; data: Object } = {
				id: this.form.key,
				path: this.form.path,
				data: editedGroup,
			};

			try {
				const response = await this.$firebase.functions().httpsCallable('editGroupDesktop')(data);
				this.loading = false;

				this.$refs.drawer.closeDrawer();

				this.$message({
					type: 'success',
					message: this.$t('groupConfig.groupEdited'),
				});
			} catch (error) {
				this.loading = false;
				console.log(error);

				this.$message({
					type: 'error',
					message: this.$translateError(error),
				});
			}
		},
		async onNewGroup(): Promise<void> {
			const valid = await this.validateForm();
			if (!valid) return;
			this.loading = true;

			const data: { path: string; group: Object; id: string } = {
				path: this.form.path,
				group: this.form,
				id: idGenerator(),
			};

			try {
				await this.$firebase.functions().httpsCallable('addGroup')(data);
				this.loading = false;

				this.$refs.drawer.closeDrawer();

				this.$message({
					type: 'success',
					message: this.$t('groupConfig.groupCreated'),
				});
			} catch (error) {
				this.loading = false;
				console.log(error);

				this.$message({
					type: 'error',
					message: this.$translateError(error),
				});
			}
		},
		handleDrawerClose(): void {
			this.currentPage = 1;
			this.$emit('handleClose');
		},
	},
	created() {
		var icons = require('@/assets/linearicons/selection.json').icons;
		this.totalIcons = icons.length;
		this.icons = icons.slice(0, 1 * 14 * 6);
	},
};
